import type {Supplier} from "../types/Supplier";
import {milesBetween} from "../seo/markets.mjs";

/**
 * Extracts a lat/lng pair from a Supplier's address coordinates.
 * @returns The parsed coordinates, or null if either value is not a valid number.
 */
export const getLatLng = (supplier: Supplier): { lat: number; lng: number } | null => {
  const lat = parseFloat(supplier.addressLatitude);
  const lng = parseFloat(supplier.addressLongitude);
  if (isNaN(lat) || isNaN(lng)) return null;
  return { lat, lng };
};


/**
 * The suppliers nearest a point first, those without coordinates last; ties keep their order.
 */
export const sortByMilesFrom = (suppliers: Supplier[], point: { lat: number; lng: number }): Supplier[] =>
  suppliers
    .map((supplier) => {
      const at = getLatLng(supplier);
      return { supplier, miles: at ? milesBetween(point, at) : Infinity };
    })
    .sort((a, b) => a.miles - b.miles)
    .map(({ supplier }) => supplier);
